export enum ExportMenuOptions {
  FilteredRows = 'filtered-rows',
  AllRows = 'all-rows',
}

export enum ApplicationTabId {
  AllApplications = 'all-applications',
  NewApplications = 'new-applications',
  ExpiringSoon = 'expiring-soon',
  RenewalApplications = 'renewal-applications',
  AllRecords = 'all-records',
  LeaseDetailsNeeded = 'lease-details-needed',
  RenewalDecisionNeeded = 'renewal-decision-needed',
  IssuedBonds = 'issued-bonds',
}

export enum SortField {
  CreatedAt = 'created_at',
  LeaseStartDate = 'lease_start_date',
  LeaseEndDate = 'lease_end_date',
}

export const SortDirection = {
  Asc: 'asc' as const,
  Desc: 'desc' as const,
  arrowState: (dir: 'asc' | 'desc'): 'asc' | 'desc' => (dir === 'asc' ? 'desc' : 'asc'),
  fromArrow: (arrow: 'asc' | 'desc' | false): 'asc' | 'desc' | false =>
    arrow === false ? false : SortDirection.arrowState(arrow),
};

// Value + type share a name so callers can `import { SortDirection }` and use it both ways.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type SortDirection = typeof SortDirection.Asc | typeof SortDirection.Desc;
